import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './BtnClose.css'
import template from './BtnClose.jinja'

var BtnClose = Backbone.View.extend({
    initialize () {
        this.$el.addClass('isNotHoverable')

        this.$leftLine = this.$('.BtnClose-left')
        this.$rightLine = this.$('.BtnClose-right')

        $.Velocity.hook(this.$el, 'opacity', 0)
        $.Velocity.hook(this.$leftLine, 'translateX', '-14px')
        $.Velocity.hook(this.$rightLine, 'translateX', '14px')
    },

    playIn(options) {
        $.Velocity.hook(this.$el, 'display', 'block')

        $.Velocity.animate(this.$el[0], {
            opacity: 1
        }, _.extend({
            duration: 600
        }))

        return $.Velocity.animate([this.$leftLine[0], this.$rightLine[0]], {
            translateX: 0,
            translateZ: 0
        }, _.extend({
            duration: 600
        }, options))
            .then(() => {
                this.$el.removeClass('isNotHoverable')
            })
    },

    playOut(options) {
        var self = this

        $.Velocity.animate(this.$el[0], {
            opacity: 0
        }, _.extend({
            duration: 600
        }))

        $.Velocity.animate(this.$rightLine[0], {
            translateX: [14, 0],
            translateZ: 0
        }, _.extend({
            begin() {
                $.Velocity.hook(self.$rightLine, 'translateX', '20px')
                self.$el.addClass('isNotHoverable')
            },
            duration: 600
        }, options))

        return $.Velocity.animate(this.$leftLine[0], {
            translateX: [-14, 0],
            translateZ: 0
        }, _.extend({
            duration: 600,
            complete() {
                $.Velocity.hook(self.$el, 'display', 'none')
            }
        }, options))
            .then(() => {
                this.$el.addClass('isNotHoverable')
            })
    }
})

export default BtnClose


// WEBPACK FOOTER //
// ./assets/app/front/components/BtnClose/BtnClose.js